export default "__VITE_ASSET__DECP$OVx__"